<template>
  <div class="user-list">
    <!-- 搜索栏 -->
    <el-card class="search-card">
      <el-form :model="searchForm" inline>
        <el-form-item label="关键词">
          <el-input
            v-model="searchForm.keyword"
            placeholder="请输入昵称/手机号"
            clearable
            style="width: 200px"
          />
        </el-form-item>
        
        <el-form-item label="身份类型">
          <el-select v-model="searchForm.userType" placeholder="请选择" clearable style="width: 150px">
            <el-option label="工人" :value="1" />
            <el-option label="包工头" :value="2" />
          </el-select>
        </el-form-item>
        
        <el-form-item label="状态">
          <el-select v-model="searchForm.status" placeholder="请选择" clearable style="width: 120px">
            <el-option label="正常" :value="1" />
            <el-option label="禁用" :value="0" />
          </el-select>
        </el-form-item>
        
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="handleSearch">搜索</el-button>
          <el-button icon="el-icon-refresh" @click="handleReset">重置</el-button>
        </el-form-item>
      </el-form>
    </el-card>
    
    <!-- 表格 -->
    <el-card class="table-card mt-20">
      <el-table :data="userList" border stripe v-loading="loading">
        <el-table-column prop="id" label="ID" width="80" />
        <el-table-column prop="userCode" label="用户标识" width="160">
          <template slot-scope="scope">
            <el-tag type="primary" size="small">{{ scope.row.userCode || '-' }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="头像" width="70">
          <template slot-scope="scope">
            <el-avatar :size="40" :src="scope.row.avatar" v-if="scope.row.avatar">
              {{ scope.row.nickname ? scope.row.nickname.charAt(0) : '用' }}
            </el-avatar>
            <el-avatar :size="40" v-else>
              {{ scope.row.nickname ? scope.row.nickname.charAt(0) : '用' }}
            </el-avatar>
          </template>
        </el-table-column>
        <el-table-column prop="nickname" label="昵称" />
        <el-table-column prop="phone" label="手机号" />
        <el-table-column prop="realName" label="真实姓名" />
        <el-table-column label="身份类型" width="100">
          <template slot-scope="scope">
            <el-tag :type="scope.row.userType === 2 ? 'warning' : 'primary'">
              {{ scope.row.userType === 2 ? '包工头' : '工人' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="状态" width="80">
          <template slot-scope="scope">
            <el-tag :type="scope.row.status === 1 ? 'success' : 'danger'">
              {{ scope.row.status === 1 ? '正常' : '禁用' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="createTime" label="注册时间" width="160">
          <template slot-scope="scope">
            {{ formatDate(scope.row.createTime) }}
          </template>
        </el-table-column>
        <el-table-column label="操作" width="150" fixed="right">
          <template slot-scope="scope">
            <el-button type="text" @click="handleView(scope.row)">查看</el-button>
            <el-button
              type="text"
              :class="scope.row.status === 1 ? 'text-danger' : 'text-success'"
              @click="handleStatus(scope.row)"
            >
              {{ scope.row.status === 1 ? '禁用' : '启用' }}
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      
      <!-- 分页 -->
      <el-pagination
        class="mt-20"
        background
        layout="total, prev, pager, next, sizes"
        :total="total"
        :page-size="pageSize"
        :current-page="pageNum"
        @current-change="handlePageChange"
        @size-change="handleSizeChange"
      />
    </el-card>
  </div>
</template>

<script>
export default {
  name: 'UserList',
  data() {
    return {
      searchForm: {
        keyword: '',
        userType: null,
        status: null
      },
      userList: [],
      total: 0,
      pageNum: 1,
      pageSize: 10,
      loading: false
    }
  },
  created() {
    this.loadUserList()
  },
  methods: {
    async loadUserList() {
      this.loading = true
      try {
        const params = {
          pageNum: this.pageNum,
          pageSize: this.pageSize,
          ...this.searchForm
        }
        const res = await this.$http.get('/admin/user/list', { params })
        this.userList = res.records || []
        this.total = res.total || 0
      } catch (error) {
        console.error(error)
      } finally {
        this.loading = false
      }
    },
    
    handleSearch() {
      this.pageNum = 1
      this.loadUserList()
    },
    
    handleReset() {
      this.searchForm = {
        keyword: '',
        userType: null,
        status: null
      }
      this.handleSearch()
    },
    
    handlePageChange(page) {
      this.pageNum = page
      this.loadUserList()
    },
    
    handleSizeChange(size) {
      this.pageSize = size
      this.handleSearch()
    },
    
    handleView(row) {
      const avatarHtml = row.avatar
        ? `<img src="${row.avatar}" style="width: 60px; height: 60px; border-radius: 50%; margin-bottom: 10px;">`
        : ''
      this.$alert(`
        <div style="text-align: center;">
          ${avatarHtml}
          <p><strong>用户标识：</strong>${row.userCode || '-'}</p>
          <p>昵称：${row.nickname || '未设置'}</p>
          <p>手机号：${row.phone || '未绑定'}</p>
          <p>真实姓名：${row.realName || '未设置'}</p>
          <p>身份类型：${row.userType === 2 ? '包工头' : '工人'}</p>
        </div>
      `, '用户详情', {
        dangerouslyUseHTMLString: true
      }).catch(() => {})
    },
    
    async handleStatus(row) {
      const action = row.status === 1 ? '禁用' : '启用'
      try {
        await this.$confirm(`确定要${action}该用户吗？`, '提示', {
          type: 'warning'
        })
        await this.$http.post('/admin/user/updateStatus', {
          id: row.id,
          status: row.status === 1 ? 0 : 1
        })
        this.$message.success('操作成功')
        this.loadUserList()
      } catch (error) {
        if (error !== 'cancel') {
          console.error(error)
        }
      }
    },
    
    formatDate(date) {
      if (!date) return '-'
      return new Date(date).toLocaleString('zh-CN')
    }
  }
}
</script>

<style scoped lang="scss">
.user-list {
  .search-card {
    ::v-deep .el-card__body {
      padding-bottom: 0;
    }
  }
  
  .text-danger {
    color: #F56C6C;
  }
  
  .text-success {
    color: #67C23A;
  }
}
</style>
